"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
function default_1(word) {
    if (!word || word.length === 0) {
        return "";
    }
    const lower = word.toLowerCase();
    return word.charAt(0).toUpperCase() + lower.slice(1);
}
//# sourceMappingURL=capitalize.js.map